import * as React from 'react';

import { RoomViewModel } from 'models';

import { RoomRateOptions } from 'components/infosite/rooms-and-rates/room-rate-options';

export interface RoomDetailsRateOptionsWrapperProps {
  position?: string;
  room?: RoomViewModel;
}

export const RoomDetailsRateOptionsWrapper: React.FunctionComponent<RoomDetailsRateOptionsWrapperProps> = ({
  position,
  room,
}: RoomDetailsRateOptionsWrapperProps) => {
  const rateOptionsProps = {
    room,
    position,
  };

  return (
    <>
      <RoomRateOptions {...rateOptionsProps} ratePlanCollection={room.ratePlans} id="infosite-room-ratePlans" />
      <RoomRateOptions
        {...rateOptionsProps}
        ratePlanCollection={room.unavailableRatePlans}
        id="infosite-room-unavailableRatePlans"
        isUnavailable={true}
      />
    </>
  );
};
